import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-asbsbtlifeandalliedscience',
  templateUrl: './asbsbtlifeandalliedscience.component.html',
  styleUrls: ['./asbsbtlifeandalliedscience.component.scss']
})
export class AsbsbtlifeandalliedscienceComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
